/**
 * Cart Gift Note
 *
 * Furori gift bottles are NOT added to the cart as a product. Instead the
 * gift is written on the order as a cart attribute ("Cadou Furori"), which
 * shows up in the order admin under "Additional details" - the warehouse
 * picks the flavour when packing.
 *
 * Eligibility (12 iKombucha bottles = 1 gift, 24 = 2) is computed in Liquid
 * by snippets/cart-gift-progress.liquid, because only Liquid knows which
 * products belong to the iKombucha collection and how many bottles a set
 * holds. This script reads that result through the Section Rendering API
 * (sections/cart-gift-data.liquid) and keeps the attribute in sync:
 * - on the theme's cart-update event, on page load and whenever the cart
 *   drawer opens (all debounced).
 */
(function () {
  var ATTRIBUTE = 'Cadou Furori';
  var SECTION_URL = '/cart?section_id=cart-gift-data';
  var CART_URL = '/cart.js';
  var UPDATE_URL = '/cart/update.js';
  var DEBOUNCE_MS = 400;

  var debounceTimer = null;
  var inFlight = null;

  // Romanian plural: 1 sticlă, 2-19 sticle, 20+ de sticle
  function bottlesLabel(n) {
    if (n === 1) return '1 sticlă';
    return n + (n >= 20 ? ' de sticle' : ' sticle');
  }

  function giftText(data) {
    if (!data || !data.gifts) return '';
    return bottlesLabel(data.gifts) + ' Furori 330 ml (aromă aleatorie) – ' +
      bottlesLabel(data.bottles) + ' iKombucha în comandă';
  }

  function readGiftData() {
    return fetch(SECTION_URL, { credentials: 'same-origin' })
      .then(function (response) { return response.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var el = doc.getElementById('cart-gift-data');
        return el ? JSON.parse(el.textContent) : null;
      });
  }

  function writeAttribute(value) {
    // An empty string removes the attribute from the cart.
    var attributes = {};
    attributes[ATTRIBUTE] = value;
    return fetch(UPDATE_URL, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attributes })
    });
  }

  function sync() {
    if (inFlight) return inFlight;
    inFlight = fetch(CART_URL, { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var current = (cart.attributes && cart.attributes[ATTRIBUTE]) || '';
        // Empty cart and nothing to clean up: skip the section request.
        if (!cart.item_count) return current ? writeAttribute('') : null;

        return readGiftData().then(function (data) {
          if (!data) return;
          var wanted = giftText(data);
          if (wanted !== current) return writeAttribute(wanted);
        });
      })
      .catch(function () {})
      .then(function () { inFlight = null; });
    return inFlight;
  }

  function scheduleSync() {
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(sync, DEBOUNCE_MS);
  }

  // Re-check every time the cart drawer opens, so the value is fresh by the
  // time the shopper can press "Finalizează comanda". The checkout button
  // itself is deliberately left alone: other scripts/apps (minimum order,
  // Samita Order Limits) gate it, and intercepting the click could bypass them.
  function watchDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof MutationObserver === 'undefined') return;
    var wasActive = drawer.classList.contains('active');
    new MutationObserver(function () {
      var isActive = drawer.classList.contains('active');
      if (isActive && !wasActive) scheduleSync();
      wasActive = isActive;
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, scheduleSync);
  }

  function init() {
    watchDrawer();
    scheduleSync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
